const layers = [
  {
    code: 'M-01',
    title: 'Method memory',
    body: 'The subscription layer. Compound delivers evolving skills across analysis, product, delivery, engineering, QA, security, and content — with monthly drops, domain packs, and breaking-change notes. This is how your team works, not what your repo contains.',
  },
  {
    code: 'M-02',
    title: 'Project memory',
    body: 'Graph indexes, vector RAG, and semantic search over this codebase — plus settled facts the team has already confirmed. The longer you run Compound on a product, the less it guesses from generic patterns, and the faster it finds the right path in a large project.',
  },
  {
    code: 'M-03',
    title: 'Working memory',
    body: 'The live traverse of a run: plan, task status, delegated work, and evidence that something actually shipped. Long efforts survive session breaks instead of dissolving into chat scrollback.',
  },
  {
    code: 'M-04',
    title: 'Institutional memory',
    body: 'Decisions, gotchas, and hard-won constraints that stick. The next sprint does not restart from zero — the system already knows what you already learned.',
  },
]

/** Four memory plates — the product thesis, ruled as a register. */
export function CompoundMemory() {
  return (
    <section id="memory" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 pt-6 pb-12 lg:px-8 lg:pt-7 lg:pb-16">
        <div className="mb-6 flex flex-col gap-2 border-b-2 border-ink pb-4 sm:flex-row sm:items-end sm:justify-between">
          <h2 className="section-title text-ink">Four kinds of memory</h2>
          <p className="text-sm leading-relaxed text-ink-muted sm:max-w-sm sm:text-right">
            The model gets sharper on your terrain the longer you survey it.
          </p>
        </div>

        <div className="cell divide-y divide-rule">
          <div className="hidden grid-cols-[6rem_14rem_1fr] gap-6 bg-sheet-edge/60 px-5 py-2.5 sm:px-7 lg:grid">
            <span className="cell-label text-ink-muted">Layer</span>
            <span className="cell-label text-ink-muted">Name</span>
            <span className="cell-label text-ink-muted">What accumulates</span>
          </div>

          {layers.map((layer) => (
            <article
              key={layer.code}
              className="grid gap-3 px-5 py-5 sm:px-7 lg:grid-cols-[6rem_14rem_1fr] lg:gap-6 lg:py-6"
            >
              <span className="datum text-overprint">{layer.code}</span>
              <h3 className="entry-title text-ink">{layer.title}</h3>
              <p className="text-[0.9375rem] leading-relaxed text-ink-muted">
                {layer.body}
              </p>
            </article>
          ))}
        </div>

        <p className="mt-5 max-w-3xl text-base leading-relaxed text-ink-muted">
          Together they cover the full SDLC in one field — from analysis and
          product work through engineering, testing, pentests, e2e, articles,
          manuals, and operational docs.
        </p>
      </div>
    </section>
  )
}
